var _circle, _path, _rect, _rect2, _rect3, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_60)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0181 25.049C48.0885 25.3645 47.3573 26.0542 46.9885 26.9636L46.8264 27.3632L46.8079 40.782L46.7893 54.2008H50.0142H53.2391V40.9537C53.2391 29.4365 53.2254 27.6544 53.1345 27.3068C52.6584 25.4864 50.7742 24.4529 49.0181 25.049ZM46.7906 58.8599L46.7899 61.7042L46.2745 61.9737C43.2945 63.5318 41.6226 66.8527 42.1301 70.2059C42.9372 75.5391 48.7737 78.5349 53.6236 76.1055C57.6078 74.1097 59.1659 69.1905 57.0615 65.2509C56.3051 63.8346 54.9833 62.5553 53.5699 61.8714L53.2391 61.7113V58.8635V56.0156H50.0152H46.7914L46.7906 58.8599Z",
    fill: "#393184"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.6396,
    y: 31.5996,
    width: 6.72,
    height: 4.2,
    rx: 2.1,
    fill: "#393184"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6396,
    y: 40,
    width: 6.72,
    height: 4.2,
    rx: 2.1,
    fill: "#393184"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6396,
    y: 48.4004,
    width: 6.72,
    height: 4.2,
    rx: 2.1,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6941 26.39V58.7C34.3516 65.4294 37.2346 73.4531 39.594 76.6238C42.8297 81.4035 48.4611 82.1791 50.8723 81.9695C56.9704 81.4664 60.5172 77.0955 61.5283 74.9729C65.3863 67.1745 60.9579 60.875 58.2615 58.7V26.39C57.2037 20.4154 52.4279 18.9741 50.1723 19.0003C44.012 19.2519 41.9534 24.0316 41.6941 26.39Z",
    fill: "url(#paint1_linear_1062_60)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6941 26.39V58.7C34.3516 65.4294 37.2346 73.4531 39.594 76.6238C42.8297 81.4035 48.4611 82.1791 50.8723 81.9695C56.9704 81.4664 60.5172 77.0955 61.5283 74.9729C65.3863 67.1745 60.9579 60.875 58.2615 58.7V26.39C57.2037 20.4154 52.4279 18.9741 50.1723 19.0003C44.012 19.2519 41.9534 24.0316 41.6941 26.39Z",
    stroke: "url(#paint2_linear_1062_60)",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7906 58.8043L46.7899 61.6486L46.2745 61.9181C43.2945 63.4761 41.6226 66.797 42.1301 70.1503C42.9372 75.4835 48.7737 78.4793 53.6236 76.0498C57.6078 74.054 59.1659 69.1349 57.0615 65.1953C56.3051 63.7789 54.9833 62.4996 53.5699 61.8157L53.2391 61.6556V58.8078V55.96H50.0152H46.7914L46.7906 58.8043Z",
    fill: "#393184"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_60",
    x: 34.85,
    y: 16.85,
    width: 30.341,
    height: 67.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_60"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_60",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_60",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_60",
    x1: 39.7866,
    y1: 24.8125,
    x2: 73.8678,
    y2: 32.1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_60",
    x1: 52.19,
    y1: 29.5,
    x2: 84.7936,
    y2: 60.9444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermal);
export default __webpack_public_path__ + "static/media/thermal.635e709f78c83440626d8ccef13de352.svg";
export { ForwardRef as ReactComponent };